module.exports = __webpack_public_path__ + "img/SKMJ_preventprocess.b419295b.png";